<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Add Data List Case">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" label-cols-lg="12" label="Control Card" id="input-" size="sm" :model.sync="model.controlCardId"   :selected="model.controlCard != null ? model.controlCard.controlCardNumber : ''" @input="getControlCards" />
				<app-input-textbox id="fieldset-qty-system" label-cols-lg="12" label="Qty System" label-for="input-qty-system" size="sm" :model.sync="model.qtySystem"  />
				<app-input-textbox id="fieldset-total-price-qty-system" label-cols-lg="12" label="Total Price Qty System" label-for="input-total-price-qty-system" size="sm" :model.sync="model.totalPriceQtySystem"  />
				<app-input-textbox id="fieldset-qty-actual" label-cols-lg="12" label="Qty Actual" label-for="input-qty-actual" size="sm" :model.sync="model.qtyActual"  />
				<app-input-textbox id="fieldset-total-price-qty-actual" label-cols-lg="12" label="Total Price Qty Actual" label-for="input-total-price-qty-actual" size="sm" :model.sync="model.totalPriceQtyActual"  />
				<app-input-textbox id="fieldset-total-difference-qty" label-cols-lg="12" label="Total Difference Qty" label-for="input-total-difference-qty" size="sm" :model.sync="model.totalDifferenceQty"  />
					</b-col>
					<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-total-difference-price" label-cols-lg="12" label="Total Difference Price" label-for="input-total-difference-price" size="sm" :model.sync="model.totalDifferencePrice"  />
				<app-input-textbox id="fieldset-differenct-percentage" label-cols-lg="12" label="Difference Percentage" label-for="input-differenct-percentage" size="sm" :model.sync="model.differenctPercentage"  />
				<app-input-datepicker id="fieldset-scanned-date" label-cols-lg="12" label="Scanned Date" size="sm" :model.sync="model.scannedDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" />
				<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-lg="12" label="Scanned By" id="input-" size="sm" :model.sync="model.scannedById"   :selected="model.scannedBy != null ? model.scannedBy.firstName : ''" @input="getUserInfos" />
				<app-input-combobox-autocomplete :options="stockOpnameDetails" optionsLabel="controlCard" optionsKey="id" label-cols-lg="12" label="Stock Opname Detail" id="input-" size="sm" :model.sync="model.stockOpnameDetailId"   :selected="model.stockOpnameDetail != null ? model.stockOpnameDetail.controlCard : ''" @input="getStockOpnameDetails" />

				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import StockOpnameResultDetail from '@/models/StockOpnameResult/StockOpnameResultDetail';
import StockOpnameResultDetailFilter from '@/filters/StockOpnameResult/StockOpnameResultDetailFilter';

import StockOpnameResult from '@/models/StockOpnameResult/StockOpnameResult';
import StockOpnameResultFilter from '@/filters/StockOpnameResult/StockOpnameResultFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import StockOpnameDetail from '@/models/StockOpname/StockOpnameDetail';
import StockOpnameDetailFilter from '@/filters/StockOpname/StockOpnameDetailFilter';
import AppLabel from '@/components/AppLabel';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	props: ['modelId', 'openPopup','addButtonMethod', 'resetMethod'],
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppLabel,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			model : {},
			errorMessage : {
			},
			controlCards : [],
			userInfos : [],
			stockOpnameDetails : [],
			isBusy: false,
		}
	},
	methods : {
		getStockOpnameResultDetail : async function(id) {
			this.isBusy = true;
			StockOpnameResultDetail.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		getStockOpnameDetails : async function(input) {
			let filter = new StockOpnameDetailFilter();
			if (input != undefined) {
				filter.controlCard = input;
			}
			StockOpnameDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnameDetails = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;
					

					
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},

	},	beforeMount() {
		//this.getControlCards();
		//this.getUserInfos();
		//this.getStockOpnameDetails();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getStockOpnameResultDetail(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getControlCards();
				this.getUserInfos();
				this.getStockOpnameDetails();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getStockOpnameResultDetail(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
